// Parcours patient (04/10/2026) : durées lisibles, seuils d'attente (orange au-delà de 30 min, rouge au-delà de 60 min)
// et lignes de la frise (étapes et attentes entre deux étapes), à partir des étapes renvoyées par be_clinique.

export const SEUIL_ORANGE = 30 * 60
export const SEUIL_ROUGE = 60 * 60

export function secondesEntre(debut, fin) {
    const a = debut ? new Date(debut).getTime() : NaN
    const b = fin instanceof Date ? fin.getTime() : (fin ? new Date(fin).getTime() : NaN)
    if (!isFinite(a) || !isFinite(b)) return null
    return Math.max(0, Math.round((b - a) / 1000))
}

export function duree(secondes) {
    if (secondes === null || secondes === undefined || !isFinite(secondes)) return '—'
    const minutes = Math.floor(secondes / 60)
    if (minutes < 1) return 'moins d’1 min'
    if (minutes < 60) return minutes + ' min'
    const heures = Math.floor(minutes / 60)
    if (heures < 24) return heures + ' h' + (minutes % 60 ? ' ' + String(minutes % 60).padStart(2, '0') : '')
    const jours = Math.floor(heures / 24)
    return jours + ' j' + (heures % 24 ? ' ' + (heures % 24) + ' h' : '')
}

export function niveauAttente(secondes) {
    if (secondes === null || secondes === undefined) return 'normal'
    if (secondes >= SEUIL_ROUGE) return 'rouge'
    if (secondes >= SEUIL_ORANGE) return 'orange'
    return 'normal'
}

function deuxChiffres(n) { return String(n).padStart(2, '0') }

export function heure(iso, maintenant) {
    if (!iso) return '—'
    const d = new Date(iso)
    if (!isFinite(d.getTime())) return '—'
    const ref = maintenant instanceof Date ? maintenant : new Date()
    const memeJour = d.getFullYear() === ref.getFullYear() && d.getMonth() === ref.getMonth() && d.getDate() === ref.getDate()
    const h = deuxChiffres(d.getHours()) + ':' + deuxChiffres(d.getMinutes())
    return memeJour ? h : deuxChiffres(d.getDate()) + '/' + deuxChiffres(d.getMonth() + 1) + ' ' + h
}

// Étapes et attentes, dans l'ordre. Une étape instantanée (sans fin) n'a pas de durée ; l'étape en cours dure jusqu'à
// maintenant. Une attente apparaît entre deux étapes séparées d'au moins une minute, et en bout de frise quand le
// patient attend (position.attente).
export function lignesFrise(etapes, position, maintenant) {
    const lignes = []
    const liste = Array.isArray(etapes) ? etapes : []
    let precedente = null
    liste.forEach((etape, index) => {
        if (precedente) {
            const ecart = secondesEntre(precedente.fin || precedente.debut, etape.debut)
            if (ecart !== null && ecart >= 60 && !precedente.en_cours) {
                lignes.push({ type: 'attente', cle: 'attente-' + index, libelle: 'Attente', secondes: ecart, niveau: niveauAttente(ecart), en_cours: false })
            }
        }
        const secondes = etape.fin ? secondesEntre(etape.debut, etape.fin) : (etape.en_cours ? secondesEntre(etape.debut, maintenant) : null)
        lignes.push({ type: 'etape', cle: 'etape-' + index, code: etape.code, titre: etape.titre, detail: etape.detail, auteur: etape.auteur || null,
            heure: heure(etape.debut, maintenant), fin: etape.fin ? heure(etape.fin, maintenant) : null, secondes, en_cours: !!etape.en_cours })
        precedente = etape
    })
    const derniere = liste[liste.length - 1]
    if (position && position.attente && derniere && !derniere.en_cours) {
        const secondes = secondesEntre(position.depuis || derniere.fin || derniere.debut, maintenant)
        lignes.push({ type: 'attente', cle: 'attente-actuelle', libelle: position.libelle, secondes, niveau: niveauAttente(secondes), en_cours: true })
    }
    return lignes
}

// « Chambre Agou » reste tel quel ; « 101 » devient « Chambre 101 ».
export function libelleChambre(chambre) {
    const texte = String(chambre || '').trim()
    if (!texte) return ''
    return /^chambre\b/i.test(texte) ? texte : 'Chambre ' + texte
}

// Pastille « où / depuis quand » : bleu dans un service ou en consultation, orange / rouge en attente, gris une fois sorti.
export function pastille(position, maintenant) {
    if (!position) return null
    const secondes = secondesEntre(position.depuis, maintenant)
    const niveau = position.code === 'sorti' ? 'sorti' : (position.attente ? niveauAttente(secondes) : 'actif')
    return { libelle: position.libelle, depuis: duree(secondes), secondes, niveau }
}
